import React, { useState } from "react";
import styles from "../../Works.module.scss";

export default function ProjectCard({ project, visible, index, onClick }) {
  const [h, setH] = useState(false);
  return (
    <div
      className={styles["ps-wrap"]}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(40px)",
        transition: `opacity .6s ease ${index * 0.1}s,transform .6s ease ${index * 0.1}s`,
      }}
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      onClick={onClick}
    >
      <div
        className={`${styles["ps-shadow"]} ${styles["s1"]}`}
        style={{
          transform: h
            ? "rotate(4deg) translateY(12px) scale(.97)"
            : "rotate(2.5deg) translateY(6px)",
        }}
      />
      <div
        className={`${styles["ps-shadow"]} ${styles["s2"]}`}
        style={{
          transform: h
            ? "rotate(-3deg) translateY(7px) scale(.98)"
            : "rotate(-1.5deg) translateY(3px)",
        }}
      />
      <div
        className={styles["ps-face"]}
        style={{
          transform: h ? "translateY(-6px)" : "translateY(0)",
          boxShadow: h
            ? "0 20px 60px rgba(0,0,0,.10)"
            : "0 2px 10px rgba(0,0,0,.05)",
          cursor: "pointer",
        }}
      >
        <div
          className={styles["ps-gold-bar"]}
          style={{ transform: h ? "scaleX(1)" : "scaleX(0)" }}
        />
        <div className={styles["ps-glow"]} style={{ opacity: h ? 1 : 0 }} />
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            marginBottom: 14,
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            style={{
              width: 46,
              height: 46,
              background: h ? "#f5a623" : "#fff8e7",
              borderRadius: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.3rem",
              transition: "background .3s",
              flexShrink: 0,
            }}
          >
            {project.icon}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 5,
              fontSize: "0.72rem",
              color: "#777",
              fontWeight: 500,
            }}
          >
            <span
              style={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: project.status === "Live" ? "#4ade80" : "#94a3b8",
                display: "inline-block",
              }}
            />
            {project.status}
          </div>
        </div>
        <div style={{ position: "relative", zIndex: 1 }}>
          <p
            style={{
              fontSize: "0.7rem",
              fontWeight: 600,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: "#f5a623",
              marginBottom: 5,
            }}
          >
            {project.category}
          </p>
          <h3
            style={{
              fontSize: "1.15rem",
              fontWeight: 700,
              color: "#1e1e1e",
              marginBottom: 10,
              lineHeight: 1.3,
              fontFamily: "Georgia,serif",
            }}
          >
            {project.title}
          </h3>
          <p
            style={{
              fontSize: "0.855rem",
              lineHeight: 1.72,
              color: "#666",
              marginBottom: 18,
            }}
          >
            {project.description}
          </p>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 6,
              marginBottom: 20,
            }}
          >
            {project.tags.slice(0, 4).map((t) => (
              <span
                key={t}
                style={{
                  padding: "4px 11px",
                  borderRadius: 50,
                  fontSize: "0.7rem",
                  fontWeight: 500,
                  background: h ? "#fff8e7" : "#f2f2f0",
                  color: h ? "#b07a10" : "#666",
                  border: `1px solid ${h ? "rgba(245,166,35,.3)" : "#e8e8e4"}`,
                  transition: "all .25s",
                }}
              >
                {t}
              </span>
            ))}
            {project.tags.length > 4 && (
              <span
                style={{
                  padding: "4px 11px",
                  borderRadius: 50,
                  fontSize: "0.7rem",
                  fontWeight: 500,
                  background: "#f2f2f0",
                  color: "#888",
                  border: "1px solid #e8e8e4",
                }}
              >
                +{project.tags.length - 4}
              </span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingTop: 14,
              borderTop: "1px solid #e8e8e4",
            }}
          >
            <span
              style={{
                fontSize: "0.74rem",
                fontWeight: 600,
                letterSpacing: "0.08em",
                color: "#f5a623",
                textTransform: "uppercase",
              }}
            >
              {project.year}
            </span>
            <span
              style={{
                fontSize: "0.8rem",
                color: h ? "#f5a623" : "#999",
                fontWeight: 600,
                transition: "color .2s",
              }}
            >
              View Details →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}